export const tileNames = {
	TEXT: { name: "Text", icon: "Text", defaultHeight: 6 },
	IMAGE: { name: "Image", icon: "Image", defaultHeight: 10, minHeight: 2, },
	VIDEO: { name: "Video", icon: "Video", defaultHeight: 10 },
	TABLE: { name: "Table", icon: "Table", defaultHeight: 6 },
	CODE: { name: "Code", icon: "Code", defaultHeight: 6 },
	WEB: { name: "Web", icon: "Web", defaultHeight: 8 },
	TWITTER: { name: "Twitter", icon: "Twitter", defaultHeight: 8 },
	GIPHY: { name: "Giphy", icon: "Giphy", defaultHeight: 8 },
	AIRTABLE: { name: "Airtable", icon: "Airtable", defaultHeight: 8 },
	FIGMA: { name: "Figma", icon: "Figma", defaultHeight: 8 },
	COLOR: { name: "Color", icon: "PaintBucket", defaultHeight: 8 },
};

export const textBlockType = {
	P: "p",
	LI: "li",
	H1: "h1",
	H2: "h2",
	H3: "h3",
	H4: "h4",
	SMALL: "small",
};


 export const tableTileType = {
	TH: "th",
	TD: "td",
};